import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import localizationConstants from 'shared/util/translation/constant';
import { isWhiteLabel } from 'shared/util/utility';
import CustomButton from '../customButton/customButton';
import { Translate } from '../translate/translate';

const OddsCustomMessage: FC = () => {
	const { t } = useTranslation();
	const OddsNotesMessages = [
		localizationConstants.note,
		localizationConstants.savePicksReminder,
		localizationConstants.pointsPublication
	];

	// Check the localStorage for the "dontShow" flag on component mount
	const [dontShow, setDontShow] = useState(() => {
		return localStorage.getItem('dontShowNotes') === 'true';
	});

	useEffect(() => {
		// Update localStorage whenever dontShow changes
		if (dontShow) {
			localStorage.setItem('dontShowNotes', 'true');
		}
	}, [dontShow]);

	const handleDontShowAgain = () => {
		setDontShow(true); // Set a flag to prevent future notifications
		toast.dismiss(); // Dismiss the current toast
	};

	if (dontShow) return <></>; // Prevent showing notification if "Don't Show Again" was clicked

	return (
		<div>
			{OddsNotesMessages.map((text, index) => (
				<p
					key={index}
					className={`mt--10 ${isWhiteLabel ? 'font-size--xxs' : 'font-size--10 line-height--14'}`}
				>
					<Translate text={text} />
					{text === localizationConstants.note ? ':' : ''}
				</p>
			))}
			<div className='custom-message-actions'>
				<CustomButton
					buttonTitle={t(localizationConstants.gotIt)}
					btnClassName='primary-button'
					onButtonClick={handleDontShowAgain}
				/>
			</div>
		</div>
	);
};

export default OddsCustomMessage;
